import { PlateThumbnailCard } from './PlateThumbnailCard';

export default PlateThumbnailCard;
